import Alpine from "alpinejs"

Alpine.components = function (...components) {
  const snakeCase = (str) =>
    str
      .replace(/([A-Z])/g, "_$1")
      .replace(/^_/, "")
      .toLowerCase()

  components.forEach((c) => {
    if (Array.isArray(c)) {
      Alpine.data(c[1], c[0])
    } else {
      Alpine.data(snakeCase(c.name), c)
    }
  })
}

export default Alpine
